"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.services = void 0;
var services;
(function (services) {
    services["ApsService"] = "SeApsService";
    services["CalendarService"] = "CalendarService";
    services["CentralService"] = "CentralService";
    services["Clare"] = "Clare";
    services["EligibilitySearchService"] = "EligibilitySearchService";
    services["MembershipService"] = "MembershipService";
    services["Ngin"] = "Ngin";
    services["ProofOfBirthService"] = "ProofOfBirthService";
    services["SeApsService"] = "SeApsService";
    services["SeFifaProvider"] = "SeFifaProvider";
    services["SeSafesportService"] = "SeSafesportService";
    services["SeSsdIntegrationService"] = "SeSsdIntegrationService";
    services["UserService"] = "UserService";
})(services = exports.services || (exports.services = {}));
